// Icon: material-symbols:fit-screen-outline
// Slug: Clamp a value to a new range
// Description: This action clamps a value to a new range. The value is first scaled to the new range, then clamped to the new range. This is useful for scaling a value to a new range, then clamping it to that range.

import { action } from '@engine'
import { inverseLerp, lerp } from '@utils/math'

action({
  name: 'fit',
  apply: (
    _,
    v: number,
    oldMin: number,
    oldMax: number,
    newMin: number,
    newMax: number,
    shouldClamp = false,
    shouldRound = false,
  ) => {
    const t = inverseLerp(oldMin, oldMax, v, shouldClamp)
    let fitted = lerp(newMin, newMax, t, shouldClamp)
    if (shouldRound) fitted = Math.round(fitted)
    return fitted
  },
})
